import React from "react";
import logo from "../assets/logo.png";

function Footer() {
  return (
    <>
    <footer className="bg-primary text-white pt-8 text-[15px]">
      <div className="container mx-auto grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8 px-4 md:px-10 py-6">
        {/* First Column: Logo, Address, Contact */}
        <div className="space-y-4">
        <a href="/"><img
            src={logo}
            alt="Logo"
            className="mb-4 w-40 object-contain"
          /></a>
          <p className="mb-2 text-lg">Pixel Innovative Solutions emerged to redefine how industries approach various mission-critical solutions.</p>
        </div>

        {/* Second Column: Quick Links */}
        <div className="space-y-4 px-16">
      <h4 className="text-xl font-semibold mb-4">Quick Links</h4>
      <ul className="space-y-2 text-lg">
        <li>
          <a href="/" className="hover:text-secondary">
            Home
          </a>
        </li>
        <li>
          <a href="/about" className="hover:text-secondary">
            About Us
          </a>
        </li>
        
        <li>
          <a href="/faq" className="hover:text-secondary">
            FAQ
          </a>
        </li>
        <li>
          <a href="/privacy-policy" className="hover:text-secondary">
            Privacy Policy
          </a>
        </li>
        <li>
          <a href="/sitemap" className="hover:text-secondary">
            Sitemap
          </a>
        </li>
        <li>
          <a href="/contact" className="hover:text-secondary">
            Contact Us
          </a>
        </li>
      </ul>
    </div>

        {/* Third Column: Contact Info */}
        <div className="space-y-4">
          <h4 className="text-xl font-semibold mb-4">Contact Us</h4>
          <p className="mb-2 text-lg">Address: Jivan Chaya HSG SOC.PL 21,<br/>Kothrud, Pune - 411038, Maharashtra</p>
          <p className="mb-2 text-lg">Phone: <a href="tel:+919730305633" className="hover:text-secondary">+91 9730305633</a></p>
          <p className="mb-4 text-lg">Email: <a href="mailto:sales@pixelinnovative.net" className="hover:text-secondary">sales@pixelinnovative.net</a></p>
          <div className="flex space-x-4 text-white">
            <a href="https://www.facebook.com/sheetalwireless/" target="_blank" rel="noreferrer" className="text-lg hover:text-secondary">
              <i className="fab fa-facebook"></i>
            </a>
            <a href="https://www.instagram.com/sheetalwireless/" target="_blank" rel="noreferrer" className=" text-lg hover:text-secondary">
              <i className="fab fa-instagram"></i>
            </a>            
            <a href="https://www.linkedin.com/in/sheetal-wireless-technologies-private-limited-pune-82082b118" target="_blank" rel="noreferrer" className="text-lg hover:text-secondary">
              <i className="fab fa-linkedin"></i>
            </a>            
          </div>
        </div>
      </div>

      {/* Footer Bottom */}
      <div className="border-t border-[#81a3e8] mt-8 py-4 text-center">
        <p className="text-sm">Designed & Developed by <a href="https://vm3techsolution.com/" className="hover:text-secondary">VM3 Tech Solutions LLP</a> ©2025 Pixel Innovative. All rights reserved.</p>
      </div>
    </footer>
    </>
  );
}

export default Footer;
